/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tumor-board-member.reducer';

export const TumorBoardMemberDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tumorBoardMemberEntity = useAppSelector(state => state.tumorBoardMember.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tumorBoardMemberDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tumorBoardMember.detail.title">TumorBoardMember</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.id">Id</Translate>
            </span>
          </dt>
          <dd>{tumorBoardMemberEntity.id}</dd>
          <dt>
            <span id="joinedAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.joinedAt">Joined At</Translate>
            </span>
            <UncontrolledTooltip target="joinedAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.joinedAt" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardMemberEntity.joinedAt}</dd>
          <dt>
            <span id="left">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.left">Left</Translate>
            </span>
            <UncontrolledTooltip target="left">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.left" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardMemberEntity.left ? 'true' : 'false'}</dd>
          <dt>
            <span id="leftAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.leftAt">Left At</Translate>
            </span>
            <UncontrolledTooltip target="leftAt">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.leftAt" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardMemberEntity.leftAt}</dd>
          <dt>
            <span id="memberId">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.memberId">Member Id</Translate>
            </span>
            <UncontrolledTooltip target="memberId">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.memberId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardMemberEntity.memberId}</dd>
          <dt>
            <span id="memberRole">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.memberRole">Member Role</Translate>
            </span>
            <UncontrolledTooltip target="memberRole">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.memberRole" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardMemberEntity.memberRole}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardMemberEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardMemberEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardMemberEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardMemberEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardMember.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardMemberEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardMember.tumorBoard">Tumor Board</Translate>
          </dt>
          <dd>{tumorBoardMemberEntity.tumorBoard ? tumorBoardMemberEntity.tumorBoard.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tumor-board-member" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tumor-board-member/${tumorBoardMemberEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TumorBoardMemberDetail;
